import { validateBirthDate } from '@jusbrasil-web/shared-utils-validators'

const MIN_SIGNUP_AGE = 16

export function isBelowMinimumAge(birthDate: string, minAge: number = MIN_SIGNUP_AGE): boolean {
  if (!validateBirthDate(birthDate)) return false

  const [year, month, day] = birthDate.split('-').map(Number)
  const now = new Date()
  const todayUTC = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  const ageDateUTC = Date.UTC(year + minAge, month - 1, day)

  return ageDateUTC > todayUTC
}
